import React, { useEffect, useState } from "react";
import {
  createClient,
  createMicrophoneAndCameraTracks,
  createScreenVideoTrack,
} from "agora-rtc-react";
import AgoraRTC from "agora-rtc-sdk-ng";
import axios from "axios";
import { URL_API } from "../init/url";
import { APP_ID_AGORA_PDULI, URL_GET_TOKEN_PDULI } from "./constants";
import { useDispatch } from "react-redux";
import { SetAlertBasic } from "../components/Alert/modul/alertBasicAction";
import { addMoreClass, removeMoreClass } from "../functions/htmlFunction";

// Dokumetasi Custom Hook Reactjs
//    Parameter: channelName:String, uid:Number
// Return Method or value:
//    - isJoin(): return (true/false)
//    - setJoin():(true/false)
//    - isConnect :return (true/false)
//    - usersJoin:[{uid:number, video:boolena, audio:bolean, agoraDetail:}]
//    - selfTracks: return ([0: audio], [1: video])
//    - isSelfTracksReady:return (true/false)
//    - setMuteSelfTracks():(type (string: audio / video), val (boolean))
//    - setShareScreen():(true/false)
// 	      - true, untuk mengatifkan sharescreen
// 	      - false, untuk menonaktifkan sharescreen
//    - isShareScreen: return (true/false),
// 	      - true, untuk bergabung dengan channel
// 	      - false, untuk menginggalkan channel

// const appId = "3f62b42cfd574fa38768ec2b3a8e281c";
// const appId = "9af3e01fb5e044528f6577ba5072edee";
const appId = APP_ID_AGORA_PDULI;

const config = {
  mode: "rtc",
  codec: "vp8",
};

const useClient = createClient(config);
const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks();

const useVideoClient = createClient(config);
const useScreenVideoTracks = createScreenVideoTrack();
// get Token from server
const getToken = async (uid, channelName) => {
  const response = await axios.post(
    URL_GET_TOKEN_PDULI,
    {
      uid: uid,
      expiredTime: 3600,
      channelName: channelName,
      role: 101,
    },
    {
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data.token;
};

// manage error message

const errorCode = (number) => {
  var time = new Date();

  switch (number) {
    case 200:
      // Duplicat Uid
      return null;
    case 602:
      // Duplicat Uid
      return {
        code: number,
        text: "Access is terminated",
        timing: time,
        type: "DANGER",
      };
    case 301:
      return {
        code: number,
        text: "You are unable to connect to Psikku. Please check your network connection and try again",
        timing: time,
        type: "DANGER",
      };
    case 401:
      return {
        code: number,
        text: "Please allow camera and audio permission",
        timing: time,
        type: "DANGER",
      };
    case 402:
      return {
        code: number,
        text: "Cancel to Share screen",
        timing: time,
        type: "WARNING",
      };
    case 601:
      return {
        code: number,
        text: "Uid alrady use",
        timing: time,
        type: "DANGER",
      };
    default:
      return { code: number, text: "Undefined", timing: time, type: "DANGER" };
  }
};

const audioUsersVolume = (client) => {
  client.enableAudioVolumeIndicator();
  client.on("volume-indicator", (volumes) => {
    let tmp = [];
    volumes.forEach((volume) => {
      // console.log(`UID ${volume.uid} Level ${volume.level}`, volume);
      if (volume.uid && volume.level > 5) {
        tmp.push(volume);
      }
      //  else if (options.uid == volume.uid && volume.level < 5) {
      // }
    });
    console.log("UID sound", tmp);
    // listUserVolume = tmp;
    return tmp;
  });
};

// registeredUsers{ name, email, uid, type}
// reacthook custom function
// return
export default function useCoreAgoraPduli(props) {
  const { channelName, uid } = props;
  const [token, setToken] = useState(null);
  const [isConnect, setIsConnect] = useState(false);
  const [isShareScreen, setShareScreenState] = useState(false);
  const [localScreenTrack, setLocalScreenTrack] = useState(null);
  const [joinChannel, setJoinChannel] = useState(null);
  const [usersJoin, setUsersJoin] = useState([]);
  const [errorInfo, setErrorInfo] = useState(null);
  const [shareScreenUid, setShareScreenUid] = useState(null);
  const [listUserVolume, setListUserVolume] = useState([]);

  const client = useClient();
  const videoClient = useVideoClient();
  const { ready, tracks, error } = useMicrophoneAndCameraTracks();
  const mediaSelfError = error;
  // const localScreen = useScreenVideoTracks();
  const [isMuteTrackSelf, setIsMuteTrackSelf] = useState({
    video: true,
    audio: true,
  });

  const dispatch = useDispatch();

  const handeGetToken = async () => {
    let token_tmp = await getToken(uid, channelName);
    console.log("agora use core set connected true token after", token_tmp);
    setToken(token_tmp);
  };

  useEffect(() => {
    if (channelName != null && uid != null) {
      handeGetToken();
    }
    console.log("agora token", channelName, uid);
  }, [channelName, uid]);

  useEffect(() => {
    let init = async (name) => {
      client.on(
        "connection-state-change",
        async (curState, revState, reason) => {
          console.log("1-test user joined", curState, revState, reason);
          let err = null;
          if (curState == "DISCONNECTED" && reason != "ID_BANNED") {
            err = errorCode(602);
          }
          if (curState == "RECONNECTING") {
            err = errorCode(301);
          }
          if (curState == "CONNECTED") {
            err = errorCode(200);
          }
          setErrorInfo(err);
        }
      );
      client.on("user-joined", async (user) => {
        console.log("1-test user-joined", user);
        setUsersJoin((prevUsers) => {
          return [...prevUsers, { uid: user.uid }];
        });
      });
      client.on("user-published", async (user, mediaType) => {
        await client.subscribe(user, mediaType);
        console.log("1-test user-published", user, mediaType);
        if (mediaType === "video") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.video = true;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });
        }
        if (mediaType === "audio") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.audio = true;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });
          user.audioTrack?.play();
        }
      });

      client.on("user-unpublished", (user, type) => {
        console.log("1-test user-unpublished", user, type);
        if (type === "audio") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.audio = false;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });

          user.audioTrack?.stop();
        }
        if (type === "video") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.video = false;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });
        }
      });

      client.on("user-left", (user) => {
        console.log("1-test user-left", user);
        // setUsers((prevUsers) => {
        //   return prevUsers.filter((User) => User.uid !== user.uid);
        // });
        setUsersJoin((prevUsers) => {
          return prevUsers.filter((User) => User.uid !== user.uid);
        });
      });

      client.on("published-user-list", (user) => {
        console.log("1-test published-user-list", user);
      });

      client.on("volume-indicator", (volumes) => {
        let tmp = [];

        volumes.forEach((volume) => {
          if (volume.uid && volume.level > 30) {
            tmp.push(volume);
          }
        });
        setListUserVolume(tmp);
        // console.log("UID sound usersVolume", tmp, tmp.length, listUserVolume);

        // Versi 2
        // let styleNormal = [
        //   "bg-gradient-to-r",
        //   "from-secondary-900",
        //   "from-20%",
        //   "via-secondary-600",
        //   "via-50%",
        //   "to-secondary-900",
        // ];
        // let styleSpeak = "bg-secondary-400";
        // volumes.forEach((volume) => {
        //   const element = document.getElementById(`vidComp-${volume.uid}`);
        //   if (element != null) {
        //     addMoreClass(element, styleNormal);
        //     if (volume.uid && volume.level > 30) {
        //       element.classList.add(styleSpeak);
        //       removeMoreClass(element, styleNormal);
        //     } else {
        //       addMoreClass(element, styleNormal);
        //       element.classList.remove(styleSpeak);
        //     }
        //   }
        // });
        // end Version 2
      });

      await client.join(appId, name, token, uid);
      if (tracks) await client.publish([tracks[0], tracks[1]]);
      setIsConnect(true);
      client.enableAudioVolumeIndicator();
    };

    if (ready && tracks && token != null && joinChannel) {
      console.log("agora use core set connected true");
      init(channelName);
    }
    if (mediaSelfError != null) {
      console.log("error permision camera and audio", mediaSelfError);
      setErrorInfo(errorCode(401));
    }
    console.log(
      "agora use core set connected true",
      ready,
      tracks,
      token,
      joinChannel,
      "==",
      ready && tracks && token != null && joinChannel
    );
  }, [channelName, client, ready, tracks, token, joinChannel]);

  useEffect(() => {
    let objA;
    if (errorInfo?.code != undefined) {
      if (errorInfo.type == "WARNING") {
        objA = {
          code: "AGORA_ER_W",
          type: errorInfo.type,
          mess: errorInfo.text,
          manualClose: true,
        };
      } else {
        objA = {
          code: "AGORA_ER",
          type: errorInfo.type,
          mess: errorInfo.text,
          manualClose: false,
        };
      }
    } else {
      objA = {
        code: "AGORA_ER",
        type: null,
        mess: null,
        manualClose: false,
      };
    }
    console.log("T003 dispatch alert ", objA);
    dispatch(SetAlertBasic(objA));
  }, [errorInfo]);

  const setSchareScreen = (val) => {
    console.log(
      "sharescreen 1 share screen action agora core",
      val,
      shareScreenUid
    );
    if (val == true) {
      let uid = shareScreenUid;
      let screenStart = async () => {
        let tokenScreen = await getToken(uid, channelName);
        await videoClient.join(appId, channelName, tokenScreen, uid);
        let screenInit = async () => {
          try {
            // const localScreenTrack = localScreen.tracks;
            const localScreenTrack = await AgoraRTC.createScreenVideoTrack();

            setLocalScreenTrack(localScreenTrack);
            await videoClient.publish(localScreenTrack);

            localScreenTrack.on("track-ended", () => {
              console.log("stopScreenSharing");
              localScreenTrack.close();
              videoClient.leave();
              videoClient.removeAllListeners();
              setShareScreenState(false);
            });
            setShareScreenState(true);
          } catch (error) {
            setErrorInfo(errorCode(402));
            console.log("2-test error share screen", error);
            videoClient.leave();
            videoClient.removeAllListeners();
          }
        };
        screenInit();
      };
      if (
        usersJoin.find((x) => x.uid == uid)?.uid == undefined &&
        uid != null
      ) {
        screenStart();
      } else {
        let err = errorCode(601);
        console.log(
          "2-test error isShareScreen",
          err,
          usersJoin.find((x) => x.uid == uid)?.uid,
          usersJoin.find((x) => x.uid == uid)
        );
        setErrorInfo(err);
      }
    } else if (val == false) {
      localScreenTrack.close();
      videoClient.leave();
      videoClient.removeAllListeners();
      setShareScreenState(false);
    }
  };
  const setJoin = async (val) => {
    if (val == false) {
      if (isShareScreen == true) {
        setSchareScreen(false);
      }
      await client.leave();
      client.removeAllListeners();
      // we close the tracks to perform cleanup
      tracks[0].close();
      tracks[1].close();
      setIsConnect(false);
    }
    setJoinChannel(val);
  };

  const setMuteSelfTracks = async (type, val) => {
    if (type === "audio") {
      tracks[0].setEnabled(val);
      setIsMuteTrackSelf((ps) => {
        return { ...ps, audio: !ps.audio };
      });
    } else if (type === "video") {
      tracks[1].setEnabled(val);
      setIsMuteTrackSelf((ps) => {
        return { ...ps, video: !ps.video };
      });
    }
  };

  console.log("agora use core", {
    usersJoin,
    isConnect,
    isSelfTracksReady: ready,
    selfTracks: tracks,
    isMuteTrackSelf,
    isShareScreen,
    errorInfo,
  });
  return {
    usersJoin,
    usersVolume: listUserVolume,
    setJoin,
    isConnect,
    isSelfTracksReady: ready,
    selfTracks: tracks,
    isMuteTrackSelf,
    setMuteSelfTracks,
    isShareScreen,
    setSchareScreen,
    setShareScreenUid,
    errorInfo,
    stats: client?.getSessionStats,
  };
}
